import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { LookupInfo } from '../model/lookup.model';
import { GlobalService } from '../service/global.service';
import {
  environment
} from 'src/environments/environment';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { CompanyInfo } from '../model/company.model';
import { LeadTansactionInfo } from '../model/leadtansaction.model';
import { ActivatedRoute, Router } from '@angular/router';
import { param } from 'jquery';
import { TokenService } from '../service/token.service';
import { CompanyGroupInfo } from '../model/CompanyGroupInfo.model';
import { SaleTeamManagementsInfo } from '../model/SaleTeamInfo.model';
import { AssetTypeInfo } from '../model/AssetTypeInfo.model';
import { AssetCategoryInfoInfo } from '../model/AssetCategoryInfoInfo.model';

@Component({
  selector: 'app-worklist-sale-lead-approval-form',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './worklist-sale-lead-approval-form.component.html',
  styleUrls: ['./worklist-sale-lead-approval-form.component.css']
})
export class WorklistSaleLeadApprovalFormComponent implements OnInit {
  /******************************* Variables ********************************/
  @Output() callbackloadworklist = new EventEmitter(); // callback to load worklist
  @Output() UpdateValueModal = new EventEmitter<{ titlemodal: string, detailmodal: string }>(); // callback to set title modal and detail
  baseurl: string;

  // Zone lead form variable
  CustomerTypeList: LookupInfo[] = []
  StatusList: LookupInfo[] = []
  CompanyList: CompanyInfo[] = []
  CompanyGroupList: CompanyGroupInfo[] = []
  TypeList: LookupInfo[] = []
  CategoryList: LookupInfo[] = []
  PhaseList: LookupInfo[] = []
  LeadTransaction: LeadTansactionInfo[] = []
  SaleTeamList: SaleTeamManagementsInfo[] = []
  AssetTypeList: AssetTypeInfo[] = []
  AssetCategoryList: AssetCategoryInfoInfo[] = [];
  hideProjectSaleOnHand: string = "";

  // array control
  itemsSupport: FormArray;
  monthNameslist: any;
  yearlist: any[];
  
  

  // variable for loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //variable input from parent component
  @Input() LeadApprovalForm: FormGroup;
  @Input() WorklistProjectSaleList: ProjectSaleInfo[] = [];
  @Input() displayiconback: boolean = false

  // variable flag insert update
  isOnUpdate: boolean;
  isSubmitted: any;
  hidProjectSaleId: number;
  hidProjectSaleRequestType: string;

  // variable modal
  titlemodal: string
  detailmodal: string

  //Route parameters
  _ProjectCode: string;
  _RequestId: string;
  _EmpCode: string;
  _Status: string;
  isReSubmit: boolean = false;

  RadioVal: string = null;
  RadioValChoice: string = "N";
  /******************************* Variables ********************************/

  /******************************* Functions ********************************/
  constructor(private httpClient: HttpClient, private formBuilder: FormBuilder, private GlobalService: GlobalService, private route: Router, private router: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    //Set param
    this.router.params.subscribe(params => {
      this._ProjectCode = params['ProjectCode'];
      this._RequestId = params['Request'];
      this._Status = params['Status'];
    });

    //GlobalService.CheckPagingAccessRights();
  }
  async ngOnInit() {

    this._EmpCode = localStorage.getItem("EmpCode");
    if (this.WorklistProjectSaleList.length == 0) {
      this.LeadApprovalForm = this.formBuilder.group({
        txtContactDate: [null, Validators.required],
        txtContactPerson: [null, Validators.required],
        txtEmail: [null],
        txtTel: [null, Validators.required],
        ddlCustomerType: [null, Validators.required],
        ddlStatus: [null],
        ddlCompanyName: [null, Validators.required],
        ddlCompanyGroupCode: [null, Validators.required],
        ddlProjectSaleTeamCode: [null, Validators.required],
        txtProjectLeadCode: [null],
        txtProjectLeadName: [null, Validators.required],
        ddlType: [null],
        ddlCategory: [null],
        txtTool: [null],
        ddlPhase: [null],
        txtEstimatePrice: [null],
        ddlExpectedClosePeriodMonth: [null],
        ddlExpectedClosePeriodYear: [null],
        arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
        txtRemark: [null],
        chkAction: [null],
        txtComment: [null],
        hideProjectSaleRequestTypeCode: [null],
        hideProjectSaleStatusWorkflowCodeCurrent: [null],
        hideProjectGroupMapping : [null],
        ddlAssetType: [null],
        ProjectSaleProductCategoryCode: [null],
        ProjectSaleDeliveryEsitmateDate: [null],
        ProjectSaleFlagContractRenewal: [null]
      },
        {
          // Used custom form validator 
          validator: []
        }

      );
      this.LoadProjectSaleDetails();
    }

    /* General data */
    this.GlobalService.loadLookup('COMPANYCUSTOMERTPYE').then((data) => {
      this.CustomerTypeList = data;
    });
    this.GlobalService.loadLookup('PROJECTSALESTATUS').then((data) => {
      this.StatusList = data;
    });
    await this.LoadCompany().then((data) => {
      this.CompanyList = data;
    });
    await this.LoadCompanyGroup().then((data) => {
      this.CompanyGroupList = data;
    });
    await this.LoadSaleTeam().then((data) => {
      this.SaleTeamList = data;
    });
    // await this.LoadAssetType().then((data) => {
    //   this.AssetTypeList = data;
    // });
    this.GlobalService.loadLookup('PROJECTSALETYPE').then((data) => {
      this.TypeList = data;
    });
    this.GlobalService.loadLookup('PROJECTSALECATEGORY').then((data) => {
      this.CategoryList = data;
    });
    this.GlobalService.loadLookup('PROJECTSALEPHASE').then((data) => {
      this.PhaseList = data;
    });
    this.monthNameslist = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    this.yearlist = this.generateArrayOfYears();

    this.loadAssetCategoryList().then((data) => {
        this.AssetCategoryList = data;
      });

    console.log("this workflow : " + this.hidProjectSaleRequestType)

  }

  async Click_onViewforUpdateLeadApprove(id) {
    $('#WorklistZone').hide();
    $('#CloseDealZone').hide();

    this.LeadApprovalForm.reset();
    this.isOnUpdate = true;

    let index = this.WorklistProjectSaleList.findIndex(x => x.ProjectSaleId == id);

    // get json object from field SupportTeam
    this.itemsSupport = this.LeadApprovalForm.get('arraySupportTeam') as FormArray;
    this.itemsSupport.clear();
    var objectSupportTeamFromJson = [];
    if (this.WorklistProjectSaleList[index].ProjectSaleSupportTeam != null && this.WorklistProjectSaleList[index].ProjectSaleSupportTeam != '') {
      objectSupportTeamFromJson = JSON.parse(this.WorklistProjectSaleList[index].ProjectSaleSupportTeam);
    }

    for (let i = 0; i < objectSupportTeamFromJson.length; i++) {
      this.itemsSupport.push(this.createItemSupportTeamName(objectSupportTeamFromJson[i].SupporTeamName));
    }
    
    this.LeadApprovalForm.patchValue({
      txtContactDate: this.GlobalService.formatDate(this.WorklistProjectSaleList[index].ProjectSaleContactDate),
      txtContactPerson: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleContactPerson),
      txtEmail: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleContactEmail),
      txtTel: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleContactTel),
      ddlCustomerType: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleCustomerType) != null ? parseInt(this.WorklistProjectSaleList[index].ProjectSaleCustomerType) : null,
      ddlStatus: this.WorklistProjectSaleList[index].ProjectSaleStatus != null ? this.WorklistProjectSaleList[index].ProjectSaleStatus : null,
      ddlCompanyName: this.WorklistProjectSaleList[index].ProjectSaleCompanyId != null ? this.WorklistProjectSaleList[index].ProjectSaleCompanyId : null,
      ddlCompanyGroupCode: this.WorklistProjectSaleList[index].ProjectSaleCompanyGroupCode != null ? this.WorklistProjectSaleList[index].ProjectSaleCompanyGroupCode : null,
      txtProjectLeadCode: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleCode),
      txtProjectLeadName: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleName),
      ddlType: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleType),
      ddlCategory: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleCategoryCode),
      txtTool: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleTool),
      ddlPhase: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSalePhase),
      txtEstimatePrice: this.numberWithCommas(this.WorklistProjectSaleList[index].ProjectSaleEstimatePrice),
      ddlExpectedClosePeriodMonth: this.WorklistProjectSaleList[index].ProjectSaleClosedPeriodMonth != null ? parseInt(this.WorklistProjectSaleList[index].ProjectSaleClosedPeriodMonth) : null,
      ddlExpectedClosePeriodYear: this.WorklistProjectSaleList[index].ProjectSaleClosedPeriodYear != null ? parseInt(this.WorklistProjectSaleList[index].ProjectSaleClosedPeriodYear) : null,
      txtRemark: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleRemark),
      hideProjectSaleRequestTypeCode: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleRequestTypeCode),
      hideProjectSaleStatusWorkflowCodeCurrent: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleStatusWorkflowCode),
      hideProjectGroupMapping: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectGroupMapping),
      ddlProjectSaleTeamCode: this.WorklistProjectSaleList[index].ProjectSaleTeamCode != null ? this.WorklistProjectSaleList[index].ProjectSaleTeamCode : null,
      ddlAssetType: this.WorklistProjectSaleList[index].ProjectSaleAssetTypeCode != null ? this.WorklistProjectSaleList[index].ProjectSaleAssetTypeCode : null,
    });

    this.hidProjectSaleId = this.WorklistProjectSaleList[index].ProjectSaleId
    this.hideProjectSaleOnHand = this.WorklistProjectSaleList[index].ProjectSaleOnHand
    //load current transaction log list
    this.LoadTansaction('1', id).then((data) => {
      this.LeadTransaction = data;
    });
    this.LoadCountTansaction('1', id);

    $('#LeadApprovalZone').show();

  }

  Click_onBacktoWorklistLeadApprove() {
    this.callbackloadworklist.emit(); //load worklist

    $('#LeadApprovalZone').hide();
    $('#WorklistZone').show();
    this.isOnUpdate = false;

    this.LeadApprovalForm.patchValue({
      txtContactDate: null,
      txtContactPerson: null,
      txtEmail: null,
      txtTel: null,
      ddlCustomerType: null,
      ddlStatus: null,
      ddlCompanyName: null,
      ddlCompanyGroupCode: null,
      txtProjectLeadCode: null,
      txtProjectLeadName: null,
      ddlType: null,
      ddlCategory: null,
      txtTool: null,
      ddlPhase: null,
      txtEstimatePrice: null,
      ddlExpectedClosePeriodMonth: null,
      ddlExpectedClosePeriodYear: null,
      arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
      txtRemark: null,
      chkAction: null,
      txtComment: null,
      hideProjectSaleRequestTypeCode: null,
      hideProjectSaleStatusWorkflowCodeCurrent: null,
      hideProjectGroupMapping : null,
      ddlProjectSaleTeamCode: null,
      ddlAssetType: null
    });


  }

  async SubmitWorklist() {
    if (this.LeadApprovalForm.valid) {

      this.hideProjectSaleOnHand = "" // set hideOnHand to empty for diabled all control
      this.loading(true, 'Submiting ...');

      // gen array support control to json
      this.itemsSupport = this.LeadApprovalForm.get('arraySupportTeam') as FormArray;
      var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = this.hidProjectSaleId;
        objectjson['ProjectGroupMapping'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['hideProjectGroupMapping'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['hideProjectGroupMapping'].value) : null;
        objectjson['ProjectSaleCode'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtProjectLeadCode'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtProjectLeadCode'].value) : null;
        objectjson['ProjectSaleContactDate'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtContactDate'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtContactDate'].value) : null;
        objectjson['ProjectSaleContactPerson'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtContactPerson'].value);
        objectjson['ProjectSaleContactEmail'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtEmail'].value)
        objectjson['ProjectSaleContactTel'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtTel'].value)
        objectjson['ProjectSaleCustomerType'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlCustomerType'].value)
        objectjson['ProjectSaleStatus'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlStatus'].value) != "" ? parseInt(this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlStatus'].value)) : 0;
        objectjson['ProjectSaleName'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtProjectLeadName'].value);
        objectjson['ProjectSaleCategoryCode'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlCategory'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlCategory'].value) : null;
        objectjson['ProjectSaleTool'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtTool'].value);
        objectjson['ProjectSaleEstimatePrice'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtEstimatePrice'].value) != "" ? parseInt(this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtEstimatePrice'].value)) : 0;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlExpectedClosePeriodMonth'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlExpectedClosePeriodMonth'].value) : null;
        objectjson['ProjectSaleClosedPeriodYear'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlExpectedClosePeriodYear'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlExpectedClosePeriodYear'].value) : null;
        objectjson['ProjectSaleSupportTeam'] = this.GlobalService.checkUndefinedString(jsonsupportteam);
        objectjson['ProjectSaleRemark'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtRemark'].value);

        objectjson['ProjectSaleRequestTypeCode'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['hideProjectSaleRequestTypeCode'].value);
        objectjson['Action'] = $('input[name="RadioAction"]:checked').val();
        objectjson['Comment'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtComment'].value);
        objectjson['ProjectSaleStatusWorkflowCodeCurrent'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['hideProjectSaleStatusWorkflowCodeCurrent'].value);


        objectjson['ProjectSaleUpdateBy'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);

       this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSaleWorklist", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.loading(false);

            this.titlemodal = 'Submit lead approval fail.';
            this.detailmodal = 'Your task was submit fail.';

            this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });


            $('#ModalError').modal();

          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.loading(false);
              this.titlemodal = 'Request for Lead Creation has been approved';
              this.detailmodal = '';

              this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });


              $('#ModalComplate').modal();

              setTimeout(() => {
                $('#ModalComplate').modal('hide');
                this.Click_onBacktoWorklistLeadApprove();
              }, 3000);
            }

          )
      }
    } else {
      this.GlobalService.validateAllFormFields(this.LeadApprovalForm);
      $('input.ng-invalid')[0].focus()
    }
  }

  generateArrayOfYears() {
    var max = new Date().getFullYear() + 5
    var min = max - 5
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }

  // load current tansaction log list
  totalLeadTransaction: number;
  totalPages_LeadTransac: number;
  currentPageNumber_LeadTransac: number = 1;
  async LoadTansaction(RequestType, ProjectSaleId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber_LeadTransac - 1) * environment.PageSizeSmall;
      var objectjson = {};
      objectjson['LeadTansactionProjectSaleRequestType'] = RequestType;
      objectjson['LeadTansactionProjectSaleId'] = ProjectSaleId;

      objectjson['rowFetch'] = environment.PageSizeSmall;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LeadTansactionInfo[]>(this.baseurl + "LeadTansaction/GetLeadTansaction", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountTansaction(RequestType, ProjectSaleId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LeadTansactionProjectSaleRequestType'] = RequestType;
      objectjson['LeadTansactionProjectSaleId'] = ProjectSaleId;

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<number>(this.baseurl + "LeadTansaction/GetCountLeadTansaction", strjson, httpOptions)
        .toPromise().then(data => {
          //this.currentPageNumber_LeadTransac = 1;
          this.totalLeadTransaction = data;//จำนวน data ทั้งหมด
          if(this.totalLeadTransaction == 0) this.currentPageNumber_LeadTransac = 0;
          this.totalPages_LeadTransac = Math.ceil(this.totalLeadTransaction / environment.PageSizeSmall);//จำนวนที่แบ่ง page ได้
        });
    }
  }

  LoadRequestFinished(page: any): void {
    this.currentPageNumber_LeadTransac = page.currentPageNumber;

    this.LoadTansaction("1", this.hidProjectSaleId).then((data) => {
      this.LeadTransaction = data;
    });
    this.LoadCountTansaction("1", this.hidProjectSaleId);
  }

  addSupport(): void {
    this.itemsSupport = this.LeadApprovalForm.get('arraySupportTeam') as FormArray;
    this.itemsSupport.push(this.createItemSupportTeamName());
  }

  removeSupportItem(indexitem): void {
    this.itemsSupport = this.LeadApprovalForm.get('arraySupportTeam') as FormArray;
    this.itemsSupport.removeAt(indexitem);
  }

  createItemSupportTeamName(value = ''): FormGroup {
    return this.formBuilder.group({
      SupporTeamName: [value],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );
  }


  ConvertFormArrayToJson(objectFormArray: FormArray): string {
    var objectarray = [];
    $.each(objectFormArray.controls, function (index, value) {
      objectarray.push(value.value);
    });

    return JSON.stringify(objectarray);

  }


  // Function on load on screen
  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }


  isFieldValid(field: string) {
    return !this.LeadApprovalForm.get(field).valid && this.LeadApprovalForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  checkpermissionactionbyOnHand() {
    var flagdisable = null;
    if (this._Status != "3" && this._Status != "4" && this._Status != "0") {
      flagdisable = true;
    }
    return flagdisable;
  }

  removeCommas(ctrl) {
    var result = ctrl.value.toString().replace(/,/g, '');
    ctrl.setValue(result);
  }

  replaceCommas(ctrl) {
    var result = ctrl.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    if (result.indexOf('.') < 0) {
      result += ".00";
    }
    ctrl.setValue(result);
  }

  numberRemoveCommas(x) {
    return x.replace(/,/g, '');
  }
  numberWithCommas(x) {
    x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (x.indexOf('.') < 0)
      x += ".00";
    return x
  }

  /******* เขียนใหม่แบบไม่ใช้ View child *******/
  async LoadProjectSaleDetails() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleCode'] = this._ProjectCode;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSaleWorklist",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.WorklistProjectSaleList = data; //เอาไว้ทำไมไม่รู้ แต่เอาไว้ก่อน
          this.InitialLeadForm(data); //อันนี้ใช้จริง
        });
    }
  }
  async LoadCompany() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['CompanyFlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      return this.httpClient.post<CompanyInfo[]>(this.baseurl + "company/GetCompany", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCompanyGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return this.httpClient.post<CompanyGroupInfo[]>(this.baseurl + "company/GetCompanyGroup", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadSaleTeam() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return this.httpClient.post<SaleTeamManagementsInfo[]>(this.baseurl + "team/GetTeamCriteria", strjson, httpOptions)
        .toPromise()
    }
  }
  async InitialLeadForm(projSaleList: ProjectSaleInfo[] = []) {
    this.LeadApprovalForm.reset();
    this.isOnUpdate = true;

    if (projSaleList.length > 0) {

      var projSaleDetail = projSaleList[0];

      // get json object from field SupportTeam
      this.itemsSupport = this.LeadApprovalForm.get('arraySupportTeam') as FormArray;
      this.itemsSupport.clear();
      var objectSupportTeamFromJson = JSON.parse(projSaleDetail.ProjectSaleSupportTeam);

      for (let i = 0; i < objectSupportTeamFromJson.length; i++) {
        this.itemsSupport.push(this.createItemSupportTeamName(objectSupportTeamFromJson[i].SupporTeamName));
      }
      
      this.LeadApprovalForm.patchValue({
        txtContactDate: this.GlobalService.formatDate(projSaleDetail.ProjectSaleContactDate),
        txtContactPerson: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleContactPerson),
        txtEmail: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleContactEmail),
        txtTel: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleContactTel),
        ddlCustomerType: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleCustomerType) != null ? parseInt(projSaleDetail.ProjectSaleCustomerType) : null,
        ddlStatus: projSaleDetail.ProjectSaleStatus != null ? projSaleDetail.ProjectSaleStatus : null,
        ddlCompanyName: projSaleDetail.ProjectSaleCompanyId != null ? projSaleDetail.ProjectSaleCompanyId : null,
        ddlCompanyGroupCode: projSaleDetail.ProjectSaleCompanyGroupCode != null ? projSaleDetail.ProjectSaleCompanyGroupCode : null,
        txtProjectLeadCode: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleCode),
        txtProjectLeadName: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleName),
        ddlType: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleType),
        ddlCategory: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleCategoryCode),
        txtTool: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleTool),
        ddlPhase: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSalePhase),
        txtEstimatePrice: this.numberWithCommas(projSaleDetail.ProjectSaleEstimatePrice),
        ddlExpectedClosePeriodMonth: projSaleDetail.ProjectSaleClosedPeriodMonth != null ? parseInt(projSaleDetail.ProjectSaleClosedPeriodMonth) : null,
        ddlExpectedClosePeriodYear: projSaleDetail.ProjectSaleClosedPeriodYear != null ? parseInt(projSaleDetail.ProjectSaleClosedPeriodYear) : null,
        txtRemark: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleRemark),
        hideProjectSaleRequestTypeCode: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleRequestTypeCode),
        hideProjectSaleStatusWorkflowCodeCurrent: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleStatusWorkflowCode),
        hideProjectGroupMapping: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectGroupMapping),
        ddlProjectSaleTeamCode: projSaleDetail.ProjectSaleTeamCode != null ? projSaleDetail.ProjectSaleTeamCode : null,
        //ddlAssetType: projSaleDetail.ProjectSaleAssetTypeCode != null ? projSaleDetail.ProjectSaleAssetTypeCode : null,
        ProjectSaleProductCategoryCode: projSaleDetail.ProjectSaleAssetCategoryCode != null ? projSaleDetail.ProjectSaleAssetCategoryCode : null,
        ProjectSaleDeliveryEsitmateDate: this.GlobalService.formatDate(projSaleDetail.ProjectSaleDeliveryEsitmateDate),
        ProjectSaleFlagContractRenewal: projSaleDetail?.ProjectSaleFlagContractRenewal === 'Y',

      });

      await this.onLoadAssetTypeByCategory(projSaleDetail.ProjectSaleAssetCategoryCode, projSaleDetail.ProjectSaleAssetTypeCode);

      console.log('Full Form Value:', this.LeadApprovalForm.getRawValue());
      console.log('ddlAssetType Control Value:', this.LeadApprovalForm.controls['ddlAssetType'].value);
      if (this.LeadApprovalForm.controls['ddlAssetType'].value == null){
        this.AssetTypeList = [];
      }

      this.hidProjectSaleId = projSaleDetail.ProjectSaleId
      this.hideProjectSaleOnHand = projSaleDetail.ProjectSaleOnHand
      this.hidProjectSaleRequestType = projSaleDetail.ProjectSaleRequestTypeCode
      //load current transaction log list
      this.LoadTansaction('1', projSaleDetail.ProjectSaleId).then((data) => {
        this.LeadTransaction = data;
      });
      
      this.LoadCountTansaction('1', projSaleDetail.ProjectSaleId);

      //Is Re-Submit?
      if (projSaleDetail.ProjectSaleCreateBy == this._EmpCode &&
        (projSaleDetail.ProjectSaleStatusWorkflowCode == "3" || projSaleDetail.ProjectSaleStatusWorkflowCode == "4")) {
        this.isReSubmit = true;
      }
    }
  }
  async OnBtnSubmitApproveWorklist_Click() {
    if (this.LeadApprovalForm.valid && (this.RadioVal != "3" || (this.RadioVal == "3" && this.RadioValChoice != ""))) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.hideProjectSaleOnHand = "" // set hideOnHand to empty for diabled all control
        this.loading(true, 'Submiting ...');

        // gen array support control to json
        this.itemsSupport = this.LeadApprovalForm.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = this.hidProjectSaleId;
        objectjson['ProjectGroupMapping'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['hideProjectGroupMapping'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['hideProjectGroupMapping'].value) : null;
        objectjson['ProjectSaleCode'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtProjectLeadCode'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtProjectLeadCode'].value) : null;
        objectjson['ProjectSaleContactDate'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtContactDate'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtContactDate'].value) : null;
        objectjson['ProjectSaleContactPerson'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtContactPerson'].value);
        objectjson['ProjectSaleContactEmail'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtEmail'].value)
        objectjson['ProjectSaleContactTel'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtTel'].value)
        objectjson['ProjectSaleCustomerType'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlCustomerType'].value)
        objectjson['ProjectSaleStatus'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlStatus'].value) != "" ? parseInt(this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlStatus'].value)) : 0;
        objectjson['ProjectSaleName'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtProjectLeadName'].value);
        objectjson['ProjectSaleCategoryCode'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlCategory'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlCategory'].value) : null;
        objectjson['ProjectSaleTool'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtTool'].value);
        objectjson['ProjectSaleEstimatePrice'] = !!(this.LeadApprovalForm.controls['txtEstimatePrice'].value) ? this.numberRemoveCommas(this.LeadApprovalForm.controls['txtEstimatePrice'].value) : 0;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlExpectedClosePeriodMonth'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlExpectedClosePeriodMonth'].value) : null;
        objectjson['ProjectSaleClosedPeriodYear'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlExpectedClosePeriodYear'].value) != "" ? this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['ddlExpectedClosePeriodYear'].value) : null;
        objectjson['ProjectSaleSupportTeam'] = this.GlobalService.checkUndefinedString(jsonsupportteam);
        objectjson['ProjectSaleRemark'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtRemark'].value);

        objectjson['ProjectSaleRequestTypeCode'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['hideProjectSaleRequestTypeCode'].value);
        objectjson['Action'] = $('input[name="RadioAction"]:checked').val();
        objectjson['ResetFlow'] = this.RadioValChoice;
        objectjson['Comment'] = this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['txtComment'].value);
        objectjson['ProjectSaleStatusWorkflowCodeCurrent'] = this.isReSubmit ? 1 : this.GlobalService.checkUndefinedString(this.LeadApprovalForm.controls['hideProjectSaleStatusWorkflowCodeCurrent'].value);

        objectjson['ProjectSaleUpdateBy'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleApprovalRequestId'] = Number(this._RequestId);
        objectjson['ProjectSaleReSubmit'] = this.isReSubmit;

        let strjson = JSON.stringify(objectjson);

       this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSaleWorklist", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.loading(false);

            this.titlemodal = 'Submit lead approval fail.';
            this.detailmodal = 'Your task was submit fail.';

            this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });


            $('#ModalError').modal();

          },
            () => {
              console.log(this.isSubmitted);
              this.loading(false);
              let text = "Request for Lead Creation has been approved";

              if(this.isSubmitted.Value == "pending"){
                text = "Request for Lead Creation pending approval";
              }
              if(this.isSubmitted.Value == "success"){
                text = "Request for Lead Creation has been approved";
              }
              if(this.isSubmitted.Value == "reject"){
                text = "Request for Lead Creation has been rejected";
              }
              if(this.isSubmitted.Value == "rework"){
                text = "Request for Lead Creation pending rework";
              }

              this.titlemodal = text;
              this.detailmodal = '';

              this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });

              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').removeClass().addClass('modal-header bg-gold');
              $('#ModalComplate').modal();
              var route = this.route;
              $('#btnOkay').on('click', function () {
                route.navigate(["/worklist-sale"]);
              });

            }
          )
      }
    } else {
      this.GlobalService.validateAllFormFields(this.LeadApprovalForm);
      $('input.ng-invalid')[0].focus()
    }
  }
  OnBtnCancel_Click() {
    this.route.navigate(["/worklist-sale"]);
  }
  OnBtnBack_Click() {
    this.route.navigate(["/worklist-sale"]);
  }

  SetRadioVal(){
    //console.log($('input[name="RadioAction"]:checked').val())

    //let test = $('input[name="RadioAction"]:checked').val();
    
    this.RadioVal = $('input[name="RadioAction"]:checked').val().toString();
    console.log(this.RadioVal)

    //return $('input[name="RadioAction"]:checked').val()
  }

  async LoadAssetType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {
        AssetCategoryCode: this.LeadApprovalForm.controls['ProjectSaleProductCategoryCode'].value,
      };

      let strjson = JSON.stringify(objectjson);

      return this.httpClient.post<AssetTypeInfo[]>(this.baseurl + "AssetType/GetAssetType", strjson, httpOptions)
        .toPromise()
    }
  }

  async onProductCategoryChange(event: any) {
    this.LeadApprovalForm.get('ddlAssetType')?.setValue(null);

    const selectedValue = event.target.value;

    var auth_token = await this.TokenService.RefreshToken();
    
    if (selectedValue) {
      await this.LoadAssetType().then((data) => {
      this.AssetTypeList = data;
      this.LeadApprovalForm.patchValue({ ddlAssetType: this.AssetTypeList[0].AssetTypeCode });
        }
      );
    }
  }

  async loadAssetCategoryList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<AssetCategoryInfoInfo[]>(this.baseurl + "AssetType/GetAssetCategory", strjson, httpOptions)
      .toPromise()
    }
  }

  async onLoadAssetTypeByCategory(categoryCode: string, defaultAssetTypeCode?: string) {    
  this.AssetTypeList = [];

  if (categoryCode) {
    await this.LoadAssetType().then((data) => {
      this.AssetTypeList = data;
      if (defaultAssetTypeCode) {
        // ใช้ค่าเดิมที่เคยบันทึกไว้
        this.LeadApprovalForm.patchValue({
          ddlAssetType: defaultAssetTypeCode
        });
      } else if (this.AssetTypeList.length > 0) {
        // default เป็น index 0
        //this.LeadApprovalForm.patchValue({ ddlAssetType: this.AssetTypeList[0].AssetTypeCode });
        this.AssetTypeList = [];
        // สมมติคุณมี FormGroup ที่ชื่อ form
        this.LeadApprovalForm.get('ddlAssetType')?.setValue('');
          }
        });
      } else {
        this.LeadApprovalForm.get('ddlAssetType')?.setValue('');
    }
  }

}
